import { observable,action,computed } from 'mobx'
import Cookies from 'js-cookie'

import {
  red,
  pink,
  purple,
  deepPurple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  yellow,
  amber,
  orange,
  deepOrange,
  brown,
  grey,
  blueGrey
} from 'material-ui/colors'

export default class UI {
 colors
 search
 catalog
 cart
 lehrplan
 collection
 newExampleForm
 newCollectionForm

 store

 constructor (store) {
  this.store = store

  this.catalog = new CatalogUI()
  this.search = new SearchUI(this.catalog)
  this.cart = new CartUI(store)
  this.lehrplan = new LehrplanUI()
  this.collection = new CollectionUI()
  this.newExampleForm = new NewExampleFormUI()
  this.newCollectionForm = new NewCollectionFormUI()
  this.colors = new ColorUI()
 }


 getZyklusAsString (kompetenzstufe) {
   let countCycles = 0
   if (kompetenzstufe.zyklus1) countCycles++
   if (kompetenzstufe.zyklus2) countCycles++
   if (kompetenzstufe.zyklus3) countCycles++
   const multipleCycles = countCycles > 1

   let s = ""
   s += kompetenzstufe.zyklus1 ? (multipleCycles ? "1|" : "1") : ""
   s += kompetenzstufe.zyklus2 ? (multipleCycles ? "2|" : "2") : ""
   s += kompetenzstufe.zyklus3 ? (multipleCycles ? "3|" : "3") : ""

   if (multipleCycles) {
    s = s.substr(0,s.length - 1)
   }

   return s
 }

 getZyklusColor (kompetenzstufe) {
  let count = 0, color = "catalog-item-color-zyklus-"
  kompetenzstufe.zyklus1 ? count++ : null
  kompetenzstufe.zyklus2 ? count++ : null
  kompetenzstufe.zyklus3 ? count++ : null

  if (count === 1) {
    if (kompetenzstufe.zyklus1) return color + "1"
    if (kompetenzstufe.zyklus2) return color + "2"
    if (kompetenzstufe.zyklus3) return color + "3"
  } else return ""
 }

}

class ColorUI {
  getColor (color) {
         if (color === red[500]) return red
    else if (color === pink[500]) return pink
    else if (color === purple[500]) return purple
    else if (color === deepPurple[500]) return deepPurple
    else if (color === indigo[500]) return indigo
    else if (color === blue[500]) return blue
    else if (color === lightBlue[500]) return lightBlue
    else if (color === cyan[500]) return cyan
    else if (color === teal[500]) return teal
    else if (color === green[500]) return green
    else if (color === lime[500]) return lime
    else if (color === yellow[500]) return yellow
    else if (color === amber[500]) return amber
    else if (color === orange[500]) return orange
    else if (color === deepOrange[500]) return deepOrange
    else if (color === brown[500]) return brown
    else if (color === grey[500]) return grey
    else if (color === blueGrey[500]) return blueGrey
  }
}

class NewCollectionFormUI {
  @observable open = false

  @action.bound handleOpen () {
    this.open = true
  }

  @action.bound handleClose () {
    this.open = false
  }
}

class NewExampleFormUI {
  @observable open = false
  @observable step = 0

  @action.bound handleOpen () {
    this.open = true
  }

  @action.bound handleClose () {
    this.open = false
  }

  @action.bound prevStep () {
    if (this.step - 1 >= 0) {
      this.step--
    }
  }

  @action.bound nextStep () {
    this.step++
  }

  @action.bound setStep (value) {
    this.step = value
  }
}

class LehrplanUI {
  @observable open = false
  @observable selectedTab = 0
  @observable stepPopoverOpen = false
  @observable competenceStep = null
  @observable competenceStepAnchorEl = null

  @action.bound handleOpen () {
    this.open = true
  }

  @action.bound handleClose () {
    this.open = false
  }

  @action.bound selectTab (value) {
    this.selectedTab = value
  }

  @action.bound setPopoverAnchorEl (el) {
    this.competenceStepAnchorEl = el
  }

  @action.bound handleOpenStepPopover (ks) {
    this.competenceStep = ks
    this.stepPopoverOpen = true
  }

  @action.bound handleCloseStepPopover () {
    this.competenceStep = null
    this.stepPopoverOpen = false
  }
}

class CartUI {
 constructor (store) {
   this.store = store
 }

 store
 @observable open = false
 @observable openEmailDialog = false
 @observable pdfMenuAnchorEl
 @observable openQRCodeDialog = false
 @observable openTitleAndDescriptionDialog = false

 isOpen () {
  if (!this.store.cart.hasItems) this.handleCloseCart()
  return this.open && this.store.cart.hasItems
 }

 @action.bound handleOpenTitleAndDescriptionDialog () {
   this.openTitleAndDescriptionDialog = true
 }

 @action.bound handleCloseTitleAndDescriptionDialog () {
   this.openTitleAndDescriptionDialog = false
 }

 @action.bound handleOpenCart () {
   this.open = true
 }

 @action.bound handleCloseCart () {
   this.open = false
 }

 @action.bound toggleCart () {
   this.open = !this.open
 }

 @action.bound handleOpenEmailDialog () {
   this.openEmailDialog = true
 }

 @action.bound handleCloseEmailDialog () {
   this.openEmailDialog = false
 }

 @action.bound handleOpenQRCodeDialog () {
   this.openQRCodeDialog = true
 }

 @action.bound handleCloseQRCodeDialog () {
   this.openQRCodeDialog = false
 }

 @action.bound setPDFMenuAnchorEl (anchorEl) {
   this.pdfMenuAnchorEl = anchorEl
 }

}

class SearchUI {
  constructor(catalog) {
    this.catalog = catalog
  }

  catalog
  @observable isSearchOpen = false

  @action.bound handleOpenSearch () {
    this.isSearchOpen = true
    this.catalog.setWindowWidth()
    this.updateLayout()
  }

  @action.bound handleCloseSearch () {
    this.isSearchOpen = false
    this.catalog.setWindowWidth()
    this.updateLayout()
  }

  @action.bound toggleSearch () {
    this.isSearchOpen = !this.isSearchOpen
    this.catalog.setWindowWidth()
    this.updateLayout()
  }

  updateLayout () {
   setTimeout( () => {
     window.dispatchEvent(new Event('resize'))
   },150)
  }

}

class CollectionUI {

  constructor () {
    this.setWindowWidth()
  }

  xs = 360
  sm = 600
  md = 960
  lg = 1280
  xl = 1920

  @observable windowWidth

  @computed get itemWidth () {
    if (this.windowWidth <= this.xs)
     return "100%"
    if (this.windowWidth > this.xs && this.windowWidth <= this.sm)
     return "100%"
    if (this.windowWidth > this.sm && this.windowWidth <= this.md)
     return "50%"
    if (this.windowWidth > this.md && this.windowWidth <= this.lg)
     return "50%"
    if (this.windowWidth > this.lg && this.windowWidth < this.xl)
     return "33%"
    if (this.windowWidth >= this.xl)
     return "33%"
  }


   @action.bound setWindowWidth () {
     this.windowWidth = window.innerWidth
   }
}


class CatalogUI {
  xs = 360
  sm = 600
  md = 960
  lg = 1280
  xl = 1920

  @observable windowWidth
  @observable cFrame
  @observable stackGrid
  @observable openDeleteDialog = false
  @observable openLinkDialog = false
  @observable openMobileMenu = false
  @observable openWelcomePage = true

  @observable openExplanation = false
  @observable openExplanationVideoSelect = true
  @observable currentExplanationVideoId = ''
  @observable dontShowExplanationAgain = false
  @observable loadedPopupOnce = false

  @action.bound checkExplanation () {
    let show = Cookies.get('explanation')
    if (show === null || show === undefined) {
      this.openExplanationVideoSelect = true
    } else {
      show = show == 'true' ? true : false
      this.openExplanation = false
      this.openExplanationVideoSelect = show
    }
  }

  @action.bound openExplanationVideo (videoId) {
    this.currentExplanationVideoId = videoId
    this.handleOpenExplanation()
    this.handleCloseExplanationVideoSelect()
  }

  @action.bound toggleShowExplanationAgain () {
    this.dontShowExplanationAgain = !this.dontShowExplanationAgain
    Cookies.set('explanation', !this.dontShowExplanationAgain, { expires: 7 })
  }

  @action.bound closeExplanationVideo () {
    this.handleCloseExplanation()
    this.handleOpenExplanationVideoSelect()
  }

  @action.bound handleOpenExplanationVideoSelect () {
    this.openExplanationVideoSelect = true
  }

  @action.bound handleCloseExplanationVideoSelect () {
    this.openExplanationVideoSelect = false
  }

  @action.bound handleOpenExplanation () {
    this.openExplanation = true
  }

  @action.bound handleCloseExplanation () {
    this.openExplanation = false
  }

  @action.bound toggleMobileMenu () {
    this.openMobileMenu = !this.openMobileMenu
  }

  @action.bound handleCloseMobileMenu () {
    this.openMobileMenu = false
  }

  @action.bound handleOpenDeleteDialog () {
    this.openDeleteDialog = true
  }

  @action.bound handleCloseDeleteDialog () {
    this.openDeleteDialog = false
  }

  @action.bound handleOpenLinkDialog () {
    this.openLinkDialog = true
  }

  @action.bound handleCloseLinkDialog () {
    this.openLinkDialog = false
  }
  @action.bound handleOpenWelcomePage () {
    this.openWelcomePage = true
  }
  @action.bound handleCloseWelcomePage () {
    this.openWelcomePage = false
  }

  @computed get itemWidth () {
    if (this.windowWidth <= this.xs)
     return "100%"
    if (this.windowWidth > this.xs && this.windowWidth <= this.sm)
     return "100%"
    if (this.windowWidth > this.sm && this.windowWidth <= this.md)
     return "50%"
    if (this.windowWidth > this.md && this.windowWidth <= this.lg)
     return "50%"
    if (this.windowWidth > this.lg && this.windowWidth < this.xl)
     return "33%"
    if (this.windowWidth >= this.xl)
     return "33%"
  }

  @action.bound setWindowWidth (delayUpdate) {
    this.windowWidth = this.cFrame.offsetWidth
  }

  @action.bound setCatalogFrame (cFrame) {
    this.cFrame = cFrame
    this.setWindowWidth()
  }
}



// WEBPACK FOOTER //
// ./src/stores/ui.js